/* MOOJO — Le Carnet / Le Panneau
   Une seule boucle rAF. prefers-reduced-motion : dérives à 0,
   chevauchements et blend conservés. */
(function () {
  var root = document.querySelector('.moojo-ed--carnet');
  if (!root) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var nodes = root.querySelectorAll('[data-carnet-drift]');
  if (!nodes.length) return;

  var raf = 0;

  function tick() {
    raf = 0;
    var vh = window.innerHeight || 1;
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var amp = reduce ? 0 : parseFloat(el.getAttribute('data-carnet-drift')) || 0;
      if (!amp) {
        el.style.transform = 'translate3d(0,0,0)';
        continue;
      }
      var r = el.getBoundingClientRect();
      var p = (r.top + r.height / 2 - vh / 2) / vh;
      if (p < -1.2 || p > 1.2) continue;
      el.style.transform = 'translate3d(0,' + (p * amp).toFixed(2) + 'px,0)';
    }
  }

  function onScroll() {
    if (raf) return;
    raf = requestAnimationFrame(tick);
  }

  tick();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
})();
